module.exports = __webpack_public_path__ + "static/media/help-icon.3a984a56.svg";